<template>
	<div class="container__login">
		<div class="container__login__main">
			<div class="container__login__main__panel">
				<img
					src="../../assets/treevia_login.png"
					alt
					class="container__login__main__panel__logo"
				/>
				<RecuperarSenhaFormVue
					:id-do-usuario="idDoUsuario"
					:token-para-redefinir-senha="tokenParaRedefinirSenha"
				/>
			</div>
		</div>
		<div class="container__login__footer">
			<Footer />
		</div>
	</div>
</template>

<script>
import Footer from '../../components/Footer/Footer'
import RecuperarSenhaFormVue from './RecuperarSenhaForm/RecuperarSenhaForm.vue'

export default {
	components: {
		RecuperarSenhaFormVue,
		Footer,
	},
	props: ['userId', 'passwordResetToken'],
	data: function () {
		return {
			idDoUsuario: '',
			tokenParaRedefinirSenha: '',
		}
	},
	beforeCreate() {
		localStorage.removeItem('jwt')
		localStorage.removeItem('email')
		localStorage.removeItem('username')
		localStorage.removeItem('user-modules')
		localStorage.removeItem('fotoUrl')
	},
	created() {
		this.idDoUsuario = this.userId
		this.tokenParaRedefinirSenha = decodeURIComponent(this.passwordResetToken)
	},
	methods: {
		setStep(step) {
			this.step = step
		},
	},
}
</script>

<style scoped>
.container__login {
	display: grid;
	grid-template-areas: 'main' 'footer';
	background-color: white;
	width: 100%;
}

.container__login__main {
	grid-area: main;
	height: calc(100vh - 2.5rem);
	display: flex;
	justify-content: center;
	align-items: center;
}

.container__login__main__panel {
	height: auto;
	width: 100%;
	max-width: 40rem;
	padding: 1.87rem;
	margin: 0 1rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	animation: container__login__main__panel__animation 1s ease-in-out;
}

@keyframes container__login__main__panel__animation {
	from {
		opacity: 0;
		transform: translateY(-20px);
	}

	to {
		opacity: 1;
		transform: translateY(0px);
	}
}

.container__login__main__panel__logo {
	width: 350px;
}

.container__login__footer {
	grid-area: footer;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}

@media screen and (min-width: 768px) {
	.container__login {
		background-color: var(--color-background);
	}

	.container__login__main__panel {
		background-color: white;
		border-radius: 5px;
		width: 35rem;
		padding: 2.5rem 3.12rem;
	}
}
</style>
